function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["selectedItems"],
  _excluded2 = ["children", "context"],
  _excluded3 = ["selectedItems"],
  _excluded4 = ["children", "context"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { useContext, Component, createRef, useId } from 'react';
import { MenuHorizontalIcon } from '@shopify/polaris-icons';
import isEqual from 'react-fast-compare';
import { useBreakpoints } from '../../utilities/breakpoints.js';
import { classNames } from '../../utilities/css.js';
import styles from './ResourceItem.scss.js';
import { SELECT_ALL_ITEMS } from '../../utilities/resource-list/types.js';
import { ResourceListContext } from '../../utilities/resource-list/context.js';
import { useI18n } from '../../utilities/i18n/hooks.js';
import { Checkbox } from '../Checkbox/Checkbox.js';
import { ButtonGroup } from '../ButtonGroup/ButtonGroup.js';
import { buttonsFrom } from '../Button/utils.js';
import { Popover } from '../Popover/Popover.js';
import { Button } from '../Button/Button.js';
import { ActionList } from '../ActionList/ActionList.js';
import { Box } from '../Box/Box.js';
import { InlineGrid } from '../InlineGrid/InlineGrid.js';
import { InlineStack } from '../InlineStack/InlineStack.js';
import { UnstyledLink } from '../UnstyledLink/UnstyledLink.js';
var BaseResourceItem = /*#__PURE__*/function (_Component) {
  function BaseResourceItem() {
    var _this;
    _classCallCheck(this, BaseResourceItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BaseResourceItem, [].concat(args));
    _this.state = {
      actionsMenuVisible: false,
      focused: false,
      focusedInner: false,
      selected: isSelected(_this.props.id, _this.props.context.selectedItems)
    };
    _this.node = null;
    _this.overlayRef = /*#__PURE__*/createRef();
    _this.buttonOverlay = /*#__PURE__*/createRef();
    _this.setNode = function (node) {
      _this.node = node;
    };
    _this.handleFocus = function (event) {
      if (event.target === _this.buttonOverlay.current || _this.node && event.target === _this.overlayRef.current) {
        _this.setState({
          focused: true,
          focusedInner: false
        });
      } else if (_this.node && _this.node.contains(event.target)) {
        _this.setState({
          focused: true,
          focusedInner: true
        });
      }
    };
    _this.handleBlur = function (_ref) {
      var relatedTarget = _ref.relatedTarget;
      if (_this.node && relatedTarget instanceof Element && _this.node.contains(relatedTarget)) {
        return;
      }
      _this.setState({
        focused: false,
        focusedInner: false
      });
    };
    _this.handleMouseOut = function () {
      _this.state.focused && _this.setState({
        focused: false,
        focusedInner: false
      });
      if (_this.props.onMouseOut) {
        _this.props.onMouseOut();
      }
    };
    _this.handleLargerSelectionArea = function (event) {
      stopPropagation(event);
      _this.handleSelection(!_this.state.selected, event.nativeEvent.shiftKey);
    };
    _this.handleSelection = function (value, shiftKey) {
      var _this$props = _this.props,
        id = _this$props.id,
        sortOrder = _this$props.sortOrder,
        onSelectionChange = _this$props.context.onSelectionChange;
      if (id == null || onSelectionChange == null) {
        return;
      }
      _this.setState({
        focused: value,
        focusedInner: value
      });
      onSelectionChange(value, id, sortOrder, shiftKey);
    };
    _this.handleClick = function (event) {
      stopPropagation(event);
      var _this$props2 = _this.props,
        id = _this$props2.id,
        onClick = _this$props2.onClick,
        url = _this$props2.url,
        selectMode = _this$props2.context.selectMode;
      var _event$nativeEvent = event.nativeEvent,
        ctrlKey = _event$nativeEvent.ctrlKey,
        metaKey = _event$nativeEvent.metaKey;
      var anchor = _this.node && _this.node.querySelector('a');
      if (selectMode) {
        _this.handleLargerSelectionArea(event);
        return;
      }
      if (anchor === event.target) {
        return;
      }
      if (onClick) {
        onClick(id);
      }
      if (url && (ctrlKey || metaKey)) {
        window.open(url, '_blank');
        return;
      }
      if (url && anchor) {
        anchor.click();
      }
    };
    _this.handleKeyUp = function (event) {
      var _this$props3 = _this.props,
        _this$props3$onClick = _this$props3.onClick,
        onClick = _this$props3$onClick === void 0 ? noop : _this$props3$onClick,
        selectMode = _this$props3.context.selectMode;
      var key = event.key;
      if (key === 'Enter' && _this.props.url && !selectMode) {
        onClick();
      }
    };
    _this.handleActionsClick = function () {
      _this.setState(function (_ref2) {
        var actionsMenuVisible = _ref2.actionsMenuVisible;
        return {
          actionsMenuVisible: !actionsMenuVisible
        };
      });
    };
    _this.handleCloseRequest = function () {
      _this.setState({
        actionsMenuVisible: false
      });
    };
    return _this;
  }
  _inherits(BaseResourceItem, _Component);
  return _createClass(BaseResourceItem, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var nextChildren = nextProps.children,
        _nextProps$context = nextProps.context,
        nextSelectedItems = _nextProps$context.selectedItems,
        restNextContext = _objectWithoutProperties(_nextProps$context, _excluded),
        restNextProps = _objectWithoutProperties(nextProps, _excluded2);
      var _this$props4 = this.props,
        children = _this$props4.children,
        _this$props4$context = _this$props4.context,
        selectedItems = _this$props4$context.selectedItems,
        restContext = _objectWithoutProperties(_this$props4$context, _excluded3),
        restProps = _objectWithoutProperties(_this$props4, _excluded4);
      var nextSelectMode = nextProps.context.selectMode;
      return !isEqual(this.state, nextState) || this.props.context.selectMode !== nextSelectMode || !nextProps.context.selectMode && (!isEqual(restProps, restNextProps) || !isEqual(restContext, restNextContext));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props5 = this.props,
        children = _this$props5.children,
        url = _this$props5.url,
        external = _this$props5.external,
        media = _this$props5.media,
        shortcutActions = _this$props5.shortcutActions,
        ariaControls = _this$props5.ariaControls,
        ariaExpanded = _this$props5.ariaExpanded,
        _this$props5$persistA = _this$props5.persistActions,
        persistActions = _this$props5$persistA === void 0 ? false : _this$props5$persistA,
        accessibilityLabel = _this$props5.accessibilityLabel,
        name = _this$props5.name,
        _this$props5$context = _this$props5.context,
        selectable = _this$props5$context.selectable,
        selectMode = _this$props5$context.selectMode,
        hasBulkActions = _this$props5$context.hasBulkActions,
        loading = _this$props5$context.loading,
        resourceName = _this$props5$context.resourceName,
        i18n = _this$props5.i18n,
        verticalAlignment = _this$props5.verticalAlignment,
        dataHref = _this$props5.dataHref,
        breakpoints = _this$props5.breakpoints,
        onMouseOver = _this$props5.onMouseOver;
      var _this$state = this.state,
        actionsMenuVisible = _this$state.actionsMenuVisible,
        focused = _this$state.focused,
        focusedInner = _this$state.focusedInner,
        selected = _this$state.selected;
      var ownedMarkup = null;
      var handleMarkup = null;
      if (selectable) {
        var checkboxAccessibilityLabel = name || accessibilityLabel || i18n.translate('Polaris.Common.checkbox');
        handleMarkup = /*#__PURE__*/React.createElement("div", {
          className: styles.CheckboxWrapper,
          onClick: stopPropagation,
          onChange: this.handleLargerSelectionArea
        }, /*#__PURE__*/React.createElement(UseId, null, function (id) {
          return /*#__PURE__*/React.createElement(Checkbox, {
            id: id,
            label: checkboxAccessibilityLabel,
            labelHidden: true,
            checked: selected,
            disabled: loading,
            bleedInlineStart: "300",
            bleedInlineEnd: "300",
            bleedBlockStart: "300",
            bleedBlockEnd: "300",
            fill: true,
            labelClassName: styles.CheckboxLabel
          });
        }));
      }
      if (media || selectable) {
        ownedMarkup = /*#__PURE__*/React.createElement(InlineStack, {
          gap: "300",
          blockAlign: media && selectable ? 'center' : getAlignment(verticalAlignment)
        }, handleMarkup, media);
      }
      var className = classNames(styles.ResourceItem, focused && styles.focused, selectable && styles.selectable, selected && styles.selected, selectMode && styles.selectMode, persistActions && styles.persistActions, focusedInner && styles.focusedInner);
      var listItemClassName = classNames(styles.ListItem, focused && !focusedInner && styles.focused, hasBulkActions && styles.hasBulkActions, selected && styles.selected, selectable && styles.selectable);
      var actionsMarkup = null;
      var disclosureMarkup = null;
      if (shortcutActions && !loading) {
        if (persistActions) {
          actionsMarkup = breakpoints !== null && breakpoints !== void 0 && breakpoints.lgUp ? /*#__PURE__*/React.createElement("div", {
            className: styles.Actions,
            onClick: stopPropagation
          }, /*#__PURE__*/React.createElement(ButtonGroup, null, buttonsFrom(shortcutActions, {
            variant: 'tertiary'
          }))) : null;
          var disclosureAccessibilityLabel = name ? i18n.translate('Polaris.ResourceList.Item.actionsDropdownLabel', {
            accessibilityLabel: name
          }) : i18n.translate('Polaris.ResourceList.Item.actionsDropdown');
          disclosureMarkup = !selectMode && breakpoints !== null && breakpoints !== void 0 && breakpoints.lgDown ? /*#__PURE__*/React.createElement("div", {
            onClick: stopPropagation
          }, /*#__PURE__*/React.createElement(Popover, {
            activator: /*#__PURE__*/React.createElement(Button, {
              accessibilityLabel: disclosureAccessibilityLabel,
              onClick: this.handleActionsClick,
              variant: "tertiary",
              icon: MenuHorizontalIcon
            }),
            onClose: this.handleCloseRequest,
            active: actionsMenuVisible
          }, /*#__PURE__*/React.createElement(ActionList, {
            items: shortcutActions
          }))) : null;
        } else if (breakpoints !== null && breakpoints !== void 0 && breakpoints.lgUp) {
          actionsMarkup = /*#__PURE__*/React.createElement("div", {
            className: styles.Actions,
            onClick: stopPropagation
          }, /*#__PURE__*/React.createElement(Box, {
            position: "absolute",
            insetBlockStart: "400",
            insetInlineEnd: "500"
          }, /*#__PURE__*/React.createElement(ButtonGroup, {
            variant: "segmented"
          }, buttonsFrom(shortcutActions, {
            size: 'slim'
          }))));
        }
      }
      var containerMarkup = /*#__PURE__*/React.createElement(Box, {
        id: this.props.id,
        position: "relative",
        paddingInlineStart: "300",
        paddingInlineEnd: "300",
        paddingBlockStart: "300",
        paddingBlockEnd: "300",
        zIndex: "var(--pc-resource-item-content-stacking-order)"
      }, /*#__PURE__*/React.createElement(InlineGrid, {
        columns: {
          xs: '1fr auto'
        }
      }, /*#__PURE__*/React.createElement(InlineGrid, {
        columns: {
          xs: media || selectable ? 'auto 1fr' : '1fr'
        },
        gap: "300"
      }, ownedMarkup, /*#__PURE__*/React.createElement(InlineStack, {
        blockAlign: getAlignment(verticalAlignment)
      }, /*#__PURE__*/React.createElement(Box, {
        width: "100%",
        padding: "0"
      }, children))), actionsMarkup, disclosureMarkup));
      var tabIndex = loading ? -1 : 0;
      var ariaLabel = accessibilityLabel || i18n.translate('Polaris.ResourceList.Item.viewItem', {
        itemName: name || resourceName && resourceName.singular || ''
      });
      var accessibleMarkup = url ? /*#__PURE__*/React.createElement(UseId, null, function (id) {
        return /*#__PURE__*/React.createElement(UnstyledLink, {
          "aria-describedby": _this2.props.id,
          "aria-label": ariaLabel,
          className: styles.Link,
          url: url,
          external: external,
          tabIndex: tabIndex,
          id: id,
          ref: _this2.overlayRef
        });
      }) : /*#__PURE__*/React.createElement("button", {
        className: styles.Button,
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        onClick: this.handleClick,
        tabIndex: tabIndex,
        ref: this.buttonOverlay
      });
      return /*#__PURE__*/React.createElement("li", {
        className: listItemClassName,
        "data-href": dataHref
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.ItemWrapper
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.setNode,
        className: className,
        onClick: this.handleClick,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onKeyUp: this.handleKeyUp,
        onMouseOver: onMouseOver,
        onMouseOut: this.handleMouseOut,
        "data-href": url
      }, accessibleMarkup, containerMarkup)));
    }

    // This fires onClick when there is a URL on the item
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var selected = isSelected(nextProps.id, nextProps.context.selectedItems);
      if (prevState.selected === selected) {
        return null;
      }
      return {
        selected: selected
      };
    }
  }]);
}(Component);
function noop() {}
function stopPropagation(event) {
  event.stopPropagation();
}
function isSelected(id, selectedItems) {
  return Boolean(selectedItems && (Array.isArray(selectedItems) && selectedItems.includes(id) || selectedItems === SELECT_ALL_ITEMS));
}
function ResourceItem(props) {
  var breakpoints = useBreakpoints();
  return /*#__PURE__*/React.createElement(BaseResourceItem, Object.assign({}, props, {
    breakpoints: breakpoints,
    context: useContext(ResourceListContext),
    i18n: useI18n()
  }));
}
function getAlignment(alignment) {
  switch (alignment) {
    case 'leading':
      return 'start';
    case 'trailing':
      return 'end';
    case 'center':
      return 'center';
    case 'fill':
      return 'stretch';
    case 'baseline':
      return 'baseline';
    default:
      return 'start';
  }
}
function UseId(props) {
  var id = useId();
  return props.children(id);
}
export { ResourceItem };